/*
 * Sends a first-time visitor to the language that suits where they are:
 * Lithuania -> Lithuanian, everywhere else -> English.
 *
 * The country comes from Shopify's own detection (IP/market), read in Liquid
 * and handed over in the config below — there is no client-side IP lookup.
 *
 * Guard rails, because a redirect on page load is easy to get wrong:
 *   - runs once per browser, then never again (a returning visitor keeps
 *     whatever language they last used)
 *   - never overrides a manual choice: picking a language in the header marks
 *     the visitor as decided
 *   - never runs in the theme editor, or if the language is already right
 *   - falls back to doing nothing if anything is missing
 */
(function () {
  var STORAGE_KEY = 'gd-locale-decided';

  function decided() {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      /* private mode: treat as decided so we never loop */
      return true;
    }
  }

  function markDecided() {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {
      /* nothing to do — the redirect simply won't be remembered */
    }
  }

  /* Picking a language by hand settles it for good. Bound whether or not the
     redirect itself runs, so a returning visitor is never second-guessed. */
  function watchManualChoice() {
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (form && form.querySelector && form.querySelector('input[name="locale_code"]')) {
          markDecided();
        }
      },
      true
    );
  }

  function run() {
    watchManualChoice();

    var el = document.querySelector('[data-gd-locale-redirect]');
    if (!el) return;

    if (window.Shopify && window.Shopify.designMode) return;
    if (decided()) return;

    var config;
    try {
      config = JSON.parse(el.getAttribute('data-gd-locale-redirect'));
    } catch (e) {
      return;
    }
    if (!config || !config.languages || !config.languages.length) return;

    var wanted = config.country === config.targetCountry ? config.targetLocale : config.defaultLocale;
    if (!wanted || wanted === config.current) {
      markDecided();
      return;
    }

    var target = null;
    var currentRoot = '/';
    for (var i = 0; i < config.languages.length; i++) {
      var lang = config.languages[i];
      if (lang.iso === wanted) target = lang;
      if (lang.iso === config.current) currentRoot = lang.root || '/';
    }

    /* the wanted language isn't published — leave the visitor where they are */
    if (!target) {
      markDecided();
      return;
    }

    var path = window.location.pathname;
    if (currentRoot !== '/' && path.indexOf(currentRoot) === 0) {
      path = path.slice(currentRoot.length) || '/';
    }

    var root = target.root && target.root !== '/' ? target.root : '';
    var next = root + (path.charAt(0) === '/' ? path : '/' + path) + window.location.search + window.location.hash;

    markDecided();
    if (next !== window.location.pathname + window.location.search + window.location.hash) {
      window.location.replace(next);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
